import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        buttonTextSignup: 'Sign up',
        buttonTextLogin: 'Login'
    },
    es: {
        buttonTextSignup: 'Registrarse',
        buttonTextLogin: 'Ingresar'
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/organisms/Navigation/NavigationContent.js